import React, {useState, useEffect} from 'react'
import { formatearFecha } from '../utils/FormatearFecha';
import API from '../utils/api';
import axios from 'axios';
import {  Button , Card, InputGroup, FloatingLabel, Form} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import { PlusLg , Eye, Search , Trash3Fill} from 'react-bootstrap-icons';
import Table from 'react-bootstrap/Table';
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Pagination from '../utils/Pagination'
import swal from 'sweetalert';


const PrestamosActivos = () => {

  const navigate = useNavigate();
  var url = API.urlAPI
  const urlPrestamo = url + "Prestamos/PrestamosActivos"
  const UrlCredito = url + "Prestamos/"

  const [prestamos, setPrestamos] = useState([]);

  const [search, setSearch] = useState("")
      // COdigo para paginado
      const [currentPage, setCurrentPage] = useState(1);
      const [recordsPerPage] = useState(25);
      const indexOfLastRecord = currentPage * recordsPerPage;
      const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
      const currentRecords = prestamos.slice(indexOfFirstRecord, indexOfLastRecord);
      const nPages = Math.ceil(prestamos.length / recordsPerPage)

const [fechaVenc , setFechaVenc] = useState ([])
  const getPrestamo = async () => {
let res = await fetch(urlPrestamo)
    let data = await res.json()
      setPrestamos(data)
      


}

const NuevoPrestamo = () => {
  navigate("NuevoPrestamo");
}

useEffect(() => {
  getPrestamo();
}, [])

const getColor = (estadoFila) => {
  if (estadoFila == "En Curso") return '#fefda6';
  return '';
};

const ContainerStyle = {
  boxShadow: '1px 2px 9px white',
  background: 'white'
};


const searcher = (e) => {
  setSearch(e.target.value)
}
const results = !search ? currentRecords : prestamos.filter((dato) => dato.IdPrestamo.toString().includes(search.toLocaleLowerCase()) || dato.Cliente.toLocaleLowerCase().includes(search.toLocaleLowerCase()) || dato.Estado.toLocaleLowerCase().includes(search.toLocaleLowerCase()) || dato.fechaMinimaPago.toString().includes(search.toLocaleLowerCase())  )



const EliminarPrestamo = (data) => {

  let id = data.IdPrestamo

  
  swal({
    title: "Deseas eliminar el Crédito?",
    text: "Se eliminara el crédito N°"+data.IdPrestamo+" del cliente "+data.Cliente+"",
    icon: "warning",
    buttons: true,
    dangerMode: true,
  })
  .then((willDelete) => {
    if (willDelete) {
      axios.delete(UrlCredito+id)
      .then(response => {
        const result = response.data;
        console.log(result)
        swal("Prestamo "+data.IdPrestamo+ " Eliminado Correctamente!", {
          icon: "success",
        })
        getPrestamo()
      }
      
      )
      .catch(err => {
        console.log(err)
        console.log("URL", UrlCredito + id)
      })
      ;
    } else {
      swal("", "No se eliminará el Crédito!", "info");
    }
  });

}
  return (
    <>
        <br></br>
        <Container>
    <br></br>
    <Card style={ContainerStyle} >
      <Card.Header style={{ background: "#005187", color:"white"}}><h3>Créditos Activos</h3></Card.Header>  
      <Card.Body>
    <Button  variant="success"
style={{
  border: 'none',
  borderRadius: '50%',
  height: '65px',
  width: '65px'
}}
onClick={() => NuevoPrestamo()}
      ><PlusLg size={"lg"}></PlusLg></Button>
    <br></br>
    <br></br>
    <InputGroup>
              <InputGroup.Text><Search/></InputGroup.Text>
              <FloatingLabel
                controlId="floatingInput"
                label="Busqueda por Cliente, Estado o N° de Prestamo"
              >
                <Form.Control value={search} onChange={searcher} type="text" />
              </FloatingLabel>
            </InputGroup>
     <br></br>
 
    <Table responsive >
                            <thead>
                                <tr style={{ background: "#5589c4", color: "white"}}>
                                <th>Acción</th>
                                    <th>N° Crédito</th>
                                    <th>Cliente</th>
                                    <th>Modalidad</th>
                                    <th>Interes</th>
                                    <th>Importe Credito</th>
                                    <th>Cantidad de Cuotas</th>
                                    <th>Cuotas Pagas</th>
                                    <th>Cuota</th>
                                    <th>Proximo Pago</th>
                                    <th>Estado</th>
                                    <th>Eliminar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {results.map((item) =>
                                 
                                    <tr key={item.IdPrestamo} style={{ background: getColor(item.Estado) }}>
                                        <td>
                                          <Link to= {`DetallePrestamo/${item.IdPrestamo} `}>
                                   <Button size={15} variant="outline-primary"><Eye/></Button> 
                                   </Link>
                                   </td>
                                    <td>{item.IdPrestamo}</td>
                                        <td>{item.Cliente}</td>
                                        <td>{item.Modalidad == '7' && <td>Semanal</td>
                                        }
                                        {item.Modalidad == '31' && <td>Mensual</td>}
                                        {item.Modalidad == '1' && <td>Diario</td>}
                                        {item.Modalidad == '15' && <td>Quincenal</td>}
                                        </td>                  
                                        <td>{item.TasaInteres}%</td>
                                        <td>${item.ImporteCredito}</td>
                                        <td>{item.CantCuotas}</td>
                                        <td>{item.CoutasPagas}</td>
                                        <td>${item.ImporteCuota}</td>
                                        <td>{formatearFecha(item.fechaMinimaPago)}</td>
                                        <td>{item.Estado}</td>
                                        <td>
                                         
                                   <Button size={15} variant="outline-danger" onClick={() => EliminarPrestamo(item)}><Trash3Fill/></Button> 
                              
                                   </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                        <Pagination
                            nPages={nPages}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
</Card.Body>
</Card>
                        </Container>


    </>
  )
}

export default PrestamosActivos